export const UPDATE_BONUS_HISTORY_PERIOD = 'BONUS_HISTORY:UPDATE_PERIOD';

export const updateBonusHistoryPeriod = () => ({
    type: UPDATE_BONUS_HISTORY_PERIOD
});
